import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import InformationToolTip from "../../../../common/components/InformationToolTip";

export default function ZeroSalesToolTip({ informationContent }) {
    const [tooltipOpen, setTooltipOpen] = useState(false);

    useEffect(() => {
        const clearToolTipOnScroll = () => {
            setTooltipOpen(false);
        };

        window.addEventListener("scroll", clearToolTipOnScroll);
        return () => {
            window.removeEventListener("scroll", clearToolTipOnScroll);
        };
    }, []);

    // Default content
    const defaultInformationContent = (
        <Box paddingY={2}>
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                Zero Sales Dashboard Overview
            </Typography>
            <ul style={{ marginTop: 0, marginBottom: 8, paddingLeft: 20 }}>
                <li>
                    <Typography variant="body2" component="span">
                        <span style={{ fontWeight: 700 }}>Top SKUs:</span> View top 888 and 4K SKUs with zero sales over selected days.
                    </Typography>
                </li>
                <li>
                    <Typography variant="body2" component="span">
                        <span style={{ fontWeight: 700 }}>Daily Updates:</span> Sales data is refreshed daily at 11 PM for the most accurate data.
                    </Typography>
                </li>
            </ul>
        </Box>
    );

    const handleTooltipChange = (value) => {
        setTooltipOpen(value);
    };

    return (
        <InformationToolTip
            onChange={handleTooltipChange}
            open={tooltipOpen}
            information={informationContent || defaultInformationContent}
        />
    );
}